import * as React from 'react';

const SvgCheckPersonalInventory = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M16.882 15.493a9.518 9.518 0 10-1.414 1.414l6.8 6.8 1.414-1.414zM9.475 3.481a3.01 3.01 0 11-3.009 3.01 3.01 3.01 0 013.009-3.01zM9.5 17.025a7.484 7.484 0 01-5.721-2.661 6.486 6.486 0 0111.41.034A7.478 7.478 0 019.5 17.025z" />
    </svg>
  );
};

export default SvgCheckPersonalInventory;
